'use strict';

window.CFC = window.CFC || {};

window.CFC.PopupForm = (function($) {
  function init() {
    const forms = document.querySelectorAll('.popupForm');
    
    // Handle link clicks and move the form to the bottom of the body, since we usually just place
    // it wherever the first link to it is.
    forms.forEach(form => {
      document.querySelectorAll(`a[href='#${ form.id }']`)
        .forEach(formLink => formLink.addEventListener('click', handleFormTrigger));
      document.body.appendChild(form);
    });
  }
  
  function handleFormTrigger(e) {
    e.preventDefault();
    const formId = e.currentTarget.getAttribute('href').replace('#', '');
    const formEl = document.getElementById(formId);
    formEl.style.display = null;
    
    const closeButton = CFC.Common.getModalCloseButtonNode();
    
    const dialogNode = document.createElement('div');
    dialogNode.classList.add('dialog--formPopupWrap');
    dialogNode.appendChild(closeButton);
    dialogNode.appendChild(formEl);
    
    const dialog = CFC.Common.createModal(dialogNode, e.currentTarget, null, 'dialog--formPopup');
    
    // When the dialog is closed, prevent the form from being destroyed.  Instead just
    // move it back to the bottom of the body and hide it.
    dialog.dialogNode.addEventListener('dialog.closing', () => {
      document.body.appendChild(formEl);
      formEl.style.display = 'none';
    });
  }
  
  $(init);
  
  return {};
})(jQuery);